import styled from 'styled-components';

//components
import $Icon from 'components/Icon';
import $Spinner from 'components/Spinner';

const formatPosition = props => `
  ${props.objectPositionX * 100}%
  ${props.objectPositionY * 100}%
`;

export const Picture = styled.div.attrs(p => ({
  style: {
    background: p.backgroundColor
  }
}))`
  overflow: hidden;
  position: relative;
`;

const BaseImage = styled.div`
  height: 100%;
  width: 100%;

  ${p =>
    p.isTransparent
      ? `
    opacity: 0;
  `
      : `
    opacity: 1;
    transition: 0.5s opacity ease-out;
  `}
`;

export const StyledImage = styled(BaseImage.withComponent('img')).attrs(p => ({
  style: {
    objectPosition: formatPosition(p)
  }
}))`
  display: ${p => (p.isHidden ? 'none' : 'block')};
  object-fit: ${p => p.objectFit};
`;

export const LegacyImage = styled(BaseImage).attrs(p => ({
  style: {
    backgroundImage: p.src ? `url("${p.src}")` : 'none',
    backgroundPosition: formatPosition(p)
  }
}))`
  background-repeat: no-repeat;
  background-size: ${p => p.objectFit};
`;

export const StyledIcon = styled($Icon)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledSpinner = StyledIcon.withComponent($Spinner);
